import React from 'react';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import {
    RaceMetaDataEwTerms,
    RaceMetaDataEwTermsItem,
} from 'src/domains/sportsbook/webview/components/raceSummary/templates/RaceMetaAnteSpecial.style';

interface RaceMetaAnteSpecialPropsType {
    marketModel: MarketModel;
}

export const RaceMetaAnteSpecial = observer(
    'RaceMetaAnteSpecial',
    ({ marketModel }: RaceMetaAnteSpecialPropsType): JSX.Element | null => {
        if (marketModel.eachWayOffered === false) {
            return null;
        }

        const termsPlaces = marketModel.eachWayTermsPlaces;
        const reduction = marketModel.eachWayTermsReduction;

        if (termsPlaces !== undefined && reduction !== undefined) {
            return (
                <RaceMetaDataEwTerms data-test='race-summary-meta'>
                    <RaceMetaDataEwTermsItem>
                        <strong>
                            <I18n
                                langKey='events.race-summary.each-way-terms.label'
                                defaultText='EW:'
                            />
                        </strong>
                    </RaceMetaDataEwTermsItem>

                    <RaceMetaDataEwTermsItem>
                        <I18n
                            langKey='events.race-summary.each-way-terms.we-are-paying'
                            defaultText='We are paying'
                        />
                    </RaceMetaDataEwTermsItem>

                    <RaceMetaDataEwTermsItem>{reduction}</RaceMetaDataEwTermsItem>

                    <RaceMetaDataEwTermsItem>
                        <I18n
                            langKey='events.race-summary.each-way-terms.for'
                            defaultText='for'
                        />
                    </RaceMetaDataEwTermsItem>

                    <RaceMetaDataEwTermsItem>
                        <I18n
                            langKey='events.race-summary.each-way-terms.places'
                            defaultText='{places} places'
                            params={{ places: termsPlaces }}
                        />
                    </RaceMetaDataEwTermsItem>
                </RaceMetaDataEwTerms>
            );
        }

        return null;
    }
);
